import React, { useCallback, useMemo, useRef } from 'react';
import MdaePopup, { MdaePopupContent, MdaePopupFooter, MdaePopupFooterEndButtons, MdaePopupFooterStartButtons, MdaePopupTitle } from '../common_widgets/popup';
import { DataGrid, Toolbar, Button } from 'devextreme-react';
import { Editing, MasterDetail } from 'devextreme-react/data-grid';
import MdaeButton from '../common_widgets/button';
import { TOGGLE_OCR_FEEDBACK_POPUP } from './reducers/case-search-reducer';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';
import { IMdaeDataGridProps } from '../common_widgets/data-grid';
import { SCAN_WITH_EXISTING_REQUESTER } from './services/scan-with-existing-requester';
import { bindActionCreators } from 'redux';
import { actions as asyncActions, callOperation } from "async-ops";
import { initiateOCRPolling } from './use-ocr-polling';
import { setProgressBarLoaderPopupValue, toggleProgressBarLoaderPopupVisible } from '../common_widgets/progress-load-indicator/component';
import { getCaseSearchCriteriaMappings } from './constants';
import { TOGGLE_NOTIFY_POPUP } from '../mdae-common-reducer';
import { NOTIFY_POPUP_TYPES } from '../common_widgets/notify-popup';

export const toggleOcrUserFeedbackPopupVisible = (dispatch, isVisible) => {
    dispatch({
        type: TOGGLE_OCR_FEEDBACK_POPUP,
        data: {
            isOcrUserFeedbackPopupVisible: isVisible,
        },
    });

}
interface IOcrUserFeedbackPopup { };

const OcrUserFeedbackPopup: React.FC<IOcrUserFeedbackPopup> = () => {
    const OcrFeedbackDataGridRef = useRef(null);
    const getOcrFeedbackDataGridInstance = () =>
        OcrFeedbackDataGridRef?.current?.instance;
    const dispatch = useDispatch();
    const claimTypeCd = useSelector(
        (state) => state["caseSearchReducer"].keyInformationCaseSearchData.claimTypeCd,
        isEqual)
    const asyncAction = bindActionCreators(
        {
            asyncOperationStart: asyncActions.asyncOperationStart,
        },
        dispatch
    );
    const isOcrUserFeedbackPopupVisible = useSelector(
        (state) => state["caseSearchReducer"].isOcrUserFeedbackPopupVisible,
        isEqual
    );
    const ocrUserFeedbackPopupClose = useCallback(() => {
        toggleOcrUserFeedbackPopupVisible(dispatch, false);
    }, [])
    const reviewer = useSelector(
        (state) => state["caseSearchReducer"].ocrJobStatus.reviewer,
        isEqual
    );
    const trigger_value = useSelector(
        (state) => state["caseSearchReducer"].ocrJobStatus.trigger_value,
        isEqual
    );
    const s3ObjectName = useSelector(
        (state) => state["caseSearchReducer"].ocrPollingData.s3ObjectName,
        isEqual
    );

    const onScanAgain = useCallback(() => {
       const  ocrDataGridInstance = getOcrFeedbackDataGridInstance();
        if (ocrDataGridInstance.hasEditData()) {

            ocrDataGridInstance.saveEditData().then((result) => {
              const data = {
                ocrFeedbackdata: ocrDataGridInstance.option("dataSource"),
                triggerValue: trigger_value,
                reviewerIdentifierText: reviewer.ReviewerIdentifierText,
              };
              callOperation(SCAN_WITH_EXISTING_REQUESTER, data).then(
                (result) => {
                  setTimeout(() => {
                    initiateOCRPolling(dispatch, asyncAction, {
                      s3ObjectName: s3ObjectName,
                    });
                  }, 2000);
                  //write desired code
                }
              );
              setProgressBarLoaderPopupValue(dispatch, 0);
              toggleProgressBarLoaderPopupVisible(
                dispatch,
                true,
                "Thinking",
                true,
              );
              toggleOcrUserFeedbackPopupVisible(dispatch, false);
            });
        }
        else{

            dispatch({
                type: TOGGLE_NOTIFY_POPUP,
                data: {
                  visible: true,
                  contentHtml: () => {
                    return <div>Please enter at least one field!</div>;
                  },
                  notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
                  closeButtonText: "OK",
                  width: 470,
                  height: 250,
                },
              })
        }

    }, [])
    const getOcrUserFeedbackTitle = useCallback(() => {
        return (
            <MdaePopupTitle
                closePopupHandler={ocrUserFeedbackPopupClose}
            >
                <span className="ai-sparkles-icon" style={{ marginRight: "6px", verticalAlign: "middle" }}></span>
                {"Enhance Smart Scan "}
                <i className="img-circle fa fa-info-circle "
                    title='Our Enhance Smart Scan functionality enables users to identify a letter’s specific category name that matches our case search criteria to improve both current and future scans.'></i>
            </MdaePopupTitle>
        );
    }, []);
    const ocrFeedbackDataGridOptions = useMemo(() => {
        return getOcrFeedbackDataDataGridOptions(claimTypeCd);
    }, []);
    const onOcrFeedbackPopupShowing = () => {

    }
    return (<MdaePopup
        height={"90%"}
        width={"40%"}
        mdaeTitleRender={getOcrUserFeedbackTitle}
        visible={isOcrUserFeedbackPopupVisible}
        onShown={onOcrFeedbackPopupShowing}
        mdaeContentRender={() => (
            <div>
                <MdaePopupContent className="ocr-user-feedback-popup-content">
                    <h5 style={{ paddingBottom: "10px" }} >
                        In the table below,please enter the corresponding category name exactly as it appears in the letter. Each letter category should match the existing MDaudit case search criteria. Once you've entered one or more, press scan again to launch the Smart Scan Process .
                    </h5>
                    <h4 className='application-section-primary-color'>{reviewer?.ReviewerName}</h4>
                    <DataGrid  ref={OcrFeedbackDataGridRef} {...ocrFeedbackDataGridOptions} >
                        <Editing
                            mode="cell"
                            allowUpdating={true}
                            allowAdding={false}
                            allowDeleting={false}
                            confirmDelete={false}
                        />
                    </DataGrid>
                </MdaePopupContent>
            </div>
        )}
        mdaeFooterRender={() => {
            return (
                <MdaePopupFooter>
                    <MdaePopupFooterStartButtons>
                        <MdaeButton
                            id={"pnlCancelOCRSUserFeedbackPopupBtn"}
                            role={"secondary"}
                            onClick={ocrUserFeedbackPopupClose}
                        >
                            Cancel
                        </MdaeButton>
                    </MdaePopupFooterStartButtons>
                    <MdaePopupFooterEndButtons>
                        <MdaeButton
                            id={"pnlScanAgainBtn"}
                            role={"primary"}
                            validationGroup={"keyInfoCaseSearchValidationGroup"}
                            onClick={onScanAgain}
                        >
                            Scan Again
                        </MdaeButton>
                    </MdaePopupFooterEndButtons>
                </MdaePopupFooter>
            );
        }}
    ></MdaePopup>);
}
const getOcrFeedbackDataDataGridOptions = (claimTypeCd) => {
    const CaseSearchCriteriaMappings = getCaseSearchCriteriaMappings(claimTypeCd);
    const ocrFeedbackdata = [
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.subscriber_id.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.subscriber_id.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.patient_last_name.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.patient_last_name.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.patient_first_name.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.patient_first_name.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.dob.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.dob.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.mrn.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.mrn.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.dos.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.dos.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.modifier.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.modifier.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.npi.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.npi.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.claim_id.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.claim_id.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.drg.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.drg.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.primary_diagnosis.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.primary_diagnosis.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.discharge_date.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.discharge_date.displayAlias,
            suggestedFieldAlias: ''
        },
        {
            reviewerField: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.pos.dynamoDBKeyExpr,
            mdauditSearchCategory: CaseSearchCriteriaMappings.caseSearchCriteriaFiedMapperObject.pos.displayAlias,
            suggestedFieldAlias: ''
        },
        // Add more data as needed
    ];

    const OcrFeedbackDataDataGridOptions: IMdaeDataGridProps = {
        id: "OcrFeedbackDataDataGrid",
        allowColumnResizing: false,
        dataSource: ocrFeedbackdata,
        showColumnLines: true,
        showBorders: true,
        showRowLines: true,
        columns: [
            { dataField: 'mdauditSearchCategory', caption: 'MDaudit Search Categories', allowEditing: false },
            { dataField: 'suggestedFieldAlias', caption: 'Scanned Document Categories' },
        ],
    }
    return OcrFeedbackDataDataGridOptions;
}

export default OcrUserFeedbackPopup;


